import Plyr from 'plyr';

export default function setupPlayer(id) {
  // eslint-disable-next-line no-new
  const player = new Plyr(`#${id}`, {
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
  });

  return player;
}
